import React from 'react'
import { AgGridReact } from "ag-grid-react";
import ModalBasic from '../../component/ModalBasic';
import TextInput from '../../../components/UIComponent/TextInput';
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown';

const itemColdefs = [
    {
        field: "drawingNo",
        headerName: "Drawing no",
        minWidth: window.innerWidth * 0.12,
        flex: 0.9,
        filter: true,
    },
    {
        field: "materialType",
        headerName: "Item type",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
    {
        field: "itemName",
        headerName: "Item details",
        minWidth: window.innerWidth * 0.2,
        flex: 2,
        filter: true,
    },
    {
        field: "quantity",
        headerName: "Quantity",
        minWidth: window.innerWidth * 0.07,
        flex: 0.6,
        filter: true,
    },
    {
        field: "rejQuantity",
        headerName: "Reject quantity",
        minWidth: window.innerWidth * 0.07,
        flex: 0.6,
        filter: true,
    },
    {
        field: "rate",
        headerName: "Rate",
        minWidth: window.innerWidth * 0.07,
        flex: 0.7,
        filter: true,
    },
    {
        field: "amount",
        headerName: "Amount",
        minWidth: window.innerWidth * 0.07,
        flex: 0.7,
        filter: true,
    },
    {
        field: "sgst",
        headerName: "SGST",
        minWidth: window.innerWidth * 0.05,
        flex: 0.5,
        filter: true,
    },
    {
        field: "sgstAmt",
        headerName: "SGST amt",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "cgst",
        headerName: "CGST",
        minWidth: window.innerWidth * 0.05,
        flex: 0.5,
        filter: true,
    },
    {
        field: "cgstAmt",
        headerName: "CGST amt",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "igst",
        headerName: "IGST",
        minWidth: window.innerWidth * 0.05,
        flex: 0.5,
        filter: true,
    },
    {
        field: "igstAmt",
        headerName: "IGST amt",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "netTotal",
        headerName: "Net total",
        minWidth: window.innerWidth * 0.08,
        flex: 0.8,
        filter: true,
    },
    {
        field: "remarks",
        headerName: "Remarks",
        minWidth: window.innerWidth * 0.08,
        flex: 0.8,
        filter: true,
    },
];

export const MaterialRejectionPopup = (props) => {
    return (
        <ModalBasic
            id="material-rejection"
            classParams="!w-[75%] overflow-y-auto"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Vendor details for material rejection</span>
                <div className='item-grp grid grid-cols-5 gap-2.5 mt-3 mb-2 pb-[8px] border-b border-slate-200 items-start'>
                    <div className='input-grp'>
                        <label>Rejection no</label>
                        <TextInput type='text'
                            id='rejectionNo' name='rejectionNo'
                            value={props.materialObject.rejectionNo}
                            handleChange={(event) => props.handleChangeForPurchase(event, 'rejectionNo')}
                            className={props.validState?.error?.rejectionNo !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Rejection date</label>
                        <TextInput type='date'
                            id='rejectionDate' name='rejectionDate'
                            value={props.materialObject.rejectionDate}
                            handleChange={(event) => props.handleChangeForPurchase(event, 'rejectionDate')}
                            className={props.validState?.error?.rejectionDate !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Rejection from</label>
                        <MultiSelectDropdown
                            drpIdentity="Select rejection"
                            options={props.materialObject.rejList}
                            value={props.materialObject.idRejection ? props.materialObject.rejList.find(x => x.value === props.materialObject.idRejection) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idRejection", 'materialObject')
                            }
                            className={props.validState?.error?.idRejection !== undefined ? "error" : ""}
                            isDisabled={true}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Auth. employee</label>
                        {/* <MultiSelectDropdown
                            drpIdentity="Select employee"
                            options={props.materialObject.EmployeeList}
                            value={props.materialObject.idEmployee ? props.materialObject.EmployeeList.find(x => x.value === props.materialObject.idEmployee) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idEmployee", 'materialObject')
                            }
                            className={props.validState?.error?.idEmployee !== undefined ? "error" : ""}
                        /> */}
                        <TextInput type='text'
                            id='usp_Users' name='usp_Users'
                            value={props.usp_Users.find(x => x.globalUserID === props.globalUserID)?.userName || ''}
                            disabled={true}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Select Vendor</label>
                        <MultiSelectDropdown
                            drpIdentity="Select wo"
                            options={props.partyAccountList}
                            value={props.materialObject.idVendor ? props.partyAccountList.find(x => x.value === props.materialObject.idVendor) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idVendor", 'materialObject')
                            }
                            className={props.validState?.error?.idVendor !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Testing date</label>
                        <TextInput type='date'
                            id='testingDate' name='testingDate'
                            value={props.materialObject.testingDate}
                            handleChange={(event) => props.handleChangeForPurchase(event, 'testingDate')}
                            className={props.validState?.error?.testingDate !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Rejection type</label>
                        <MultiSelectDropdown
                            drpIdentity="Select rejection"
                            options={props.materialObject.rejTypeList}
                            value={props.materialObject.idRejType ? props.materialObject.rejTypeList.find(x => x.value === props.materialObject.idRejType) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idRejType", 'materialObject')
                            }
                            className={props.validState?.error?.idRejType !== undefined ? "error" : ""}
                        />
                    </div>
                    {/* <div className='btn-grp flex gap-2.5 mt-5'>
                        <button className="save-btn btns py-[10px] px-[20px] h-[40px]" >Generate</button>
                    </div> */}

                </div>
                <span className="text-blue text-[16px] font-semibold">Item details</span>
                <div className='item-grp grid grid-cols-5 gap-2.5 mt-3 mb-2 pb-[8px] border-b border-slate-200 items-start'>
                    <div className='input-grp'>
                        <label>Drawing no</label>
                        <TextInput type='text'
                            id='drawingNo' name='drawingNo'
                            value={props.itemObject.drawingNo}
                            handleChange={(event) => props.handleChangeForItem(event, 'drawingNo')}
                            className={props.validState?.error?.drawingNo !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Select type</label>
                        <MultiSelectDropdown
                            drpIdentity="Select type"
                            options={props.itemObject.TypeList}
                            value={props.itemObject.idType ? props.itemObject.TypeList.find(x => x.value === props.itemObject.idType) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idType", 'itemObject')
                            }
                            className={props.validState?.error?.idType !== undefined ? "error" : ""}
                            isDisabled={props.materialObject.idVendor > 0 ? false : true}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Item name</label>
                        {/* <MultiSelectDropdown
                            drpIdentity="Select priority"
                            options={props.itemObject.ItemList}
                            value={props.itemObject.idItem ? props.itemObject.ItemList.find(x => x.value === props.itemObject.idItem) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idItem", 'itemObject')
                            }
                            className={props.validState?.error?.idItem !== undefined ? "error" : ""}
                        /> */}
                        <TextInput
                            id="SelectItem"
                            name="SelectItem"
                            value={props.itemObject.itemIdLabel}
                            handleOnClick={(event) => props.handleOnClick(event, "itemList")}
                            disabled={props.materialObject.idVendor > 0 ? false : true}
                        // className={props.validState?.error?.chequeBookSeries !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Quantity</label>
                        <TextInput type='number'
                            id='quantity' name='quantity'
                            value={props.itemObject.quantity}
                            handleChange={(event) => props.handleChangeForItem(event, 'quantity')}
                            className={props.validState?.error?.quantity !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Rate</label>
                        <TextInput type='number'
                            id='rate' name='rate'
                            value={props.itemObject.rate}
                            handleChange={(event) => props.handleChangeForItem(event, 'rate')}
                            className={props.validState?.error?.rate !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Amount</label>
                        <TextInput type='number'
                            id='amount' name='amount'
                            value={props.itemObject.amount}
                            handleChange={(event) => props.handleChangeForItem(event, 'amount')}
                            className={props.validState?.error?.amount !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Tax group</label>
                        <MultiSelectDropdown
                            drpIdentity="Select tax"
                            options={props.itemObject.taxList}
                            value={props.itemObject.idTaxGroup ? props.itemObject.taxList.find(x => x.value === props.itemObject.idTaxGroup) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idTaxGroup", 'itemObject')
                            }
                            className={props.validState?.error?.idTaxGroup !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>SGST {props.itemObject.sgst > 0 ? `- ${props.itemObject.sgst}%` : ""}</label>
                        <TextInput type='number'
                            id='sgstAmt' name='sgstAmt'
                            value={props.itemObject.sgstAmt}
                            handleChange={(event) => props.handleChangeForItem(event, 'sgstAmt')}
                            className={props.validState?.error?.sgstAmt !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>CGST {props.itemObject.cgst > 0 ? `- ${props.itemObject.cgst}%` : ""}</label>
                        <TextInput type='number'
                            id='cgstAmt' name='cgstAmt'
                            value={props.itemObject.cgstAmt}
                            handleChange={(event) => props.handleChangeForItem(event, 'cgstAmt')}
                            className={props.validState?.error?.cgstAmt !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>IGST {props.itemObject.igst > 0 ? `- ${props.itemObject.igst}%` : ""}</label>
                        <TextInput type='number'
                            id='igstAmt' name='igstAmt'
                            value={props.itemObject.igstAmt}
                            handleChange={(event) => props.handleChangeForItem(event, 'igstAmt')}
                            className={props.validState?.error?.igstAmt !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Net total</label>
                        <TextInput type='number'
                            id='netTotal' name='netTotal'
                            value={props.itemObject.netTotal}
                            handleChange={(event) => props.handleChangeForItem(event, 'netTotal')}
                            className={props.validState?.error?.netTotal !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Remarks</label>
                        <TextInput type='text'
                            id='remarks' name='remarks'
                            value={props.itemObject.remarks}
                            handleChange={(event) => props.handleChangeForItem(event, 'remarks')}
                            className={props.validState?.error?.remarks !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='btn-grp flex gap-2.5 col-span-2 mt-5'>
                        {props.itemObject.keyId > 0 ?
                            <button className="save-btn btns py-[10px] px-[20px]" onClick={() => props.insert("Update")}>Update</button>
                            :
                            <button className="save-btn btns py-[10px] px-[20px]" onClick={() => props.insert("Insert")}>Insert</button>
                        }
                        <button className="edit-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => props.clearItemObject()}>Clear</button>
                        <button className="delete-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => props.delete(props.itemObject.keyId)}>Delete</button>
                    </div>
                </div>
                <div className="register-table h-[40vh]">
                    <div className="table-inner h-full">
                        <AgGridReact
                            rowData={props.itemRowData}
                            columnDefs={itemColdefs}
                            onCellClicked={props.onItemRowDataClicked}
                            // onGridReady={props.onGridReady}
                            overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                            overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                        />
                    </div>
                </div>
                <div className='total-amt mt-2.5 p-2.5 bg-[#3f8cff1a] rounded-[10px]'>
                    <span className="text-blue text-[16px] font-semibold">Amount details</span>
                    <div className='input-grp-outer grid grid-cols-6 gap-2.5 mt-2.5'>
                        <div className='input-grp'>
                            <label>Total quantity</label>
                            <TextInput type='text'
                                id='totalQty' name='totalQty'
                                value={props.materialObject.totalQty}
                                handleChange={(event) => props.handleChangeForItem(event, 'totalQty')}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Total amount</label>
                            <TextInput type='text'
                                id='totalAmt' name='totalAmt'
                                value={props.materialObject.totalAmt}
                                handleChange={(event) => props.handleChangeForItem(event, 'totalAmt')}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Tax amount</label>
                            <TextInput type='text'
                                id='taxAmt' name='taxAmt'
                                value={props.materialObject.taxAmt}
                                handleChange={(event) => props.handleChangeForItem(event, 'taxAmt')}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Total with tax</label>
                            <TextInput type='text'
                                id='totalwithTax' name='totalwithTax'
                                value={props.materialObject.totalwithTax}
                                handleChange={(event) => props.handleChangeForItem(event, 'totalwithTax')}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Adjustable amount</label>
                            <TextInput type='number'
                                id='adjustableAmt' name='adjustableAmt'
                                value={props.materialObject.adjustableAmt}
                                handleChange={(event) => props.handleChangeForPurchase(event, 'adjustableAmt')}
                                className='font-semibold'
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Final amount</label>
                            <TextInput type='text'
                                id='finalAmt' name='finalAmt'
                                value={props.materialObject.finalAmt}
                                handleChange={(event) => props.handleChangeForItem(event, 'finalAmt')}
                                className='font-semibold'
                                disabled
                            />
                        </div>

                    </div>
                </div>
                <div className='btn-grp flex gap-2.5 mt-5'>
                    <button className="update-btn btns" onClick={() => props.submit()} disabled={props.isSaving}>Save</button>
                    {/* <button className="print-btn btns">Print</button>
                    <button className="edit-btn btns">Preview</button> */}
                    <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                </div>
            </div>

        </ModalBasic>
    )
}